<template>
	<el-dialog :close-on-click-modal="false"  :title="expressData.e_number+' 快递查询'" :visible.sync="expressModel" top="5vh" @close="hide" :width="isphone?'90%':'50%'">

		<!-- 表單内容 -->
		
		 <el-timeline v-if="expressData.is_data==1" :reverse="true">
		    <el-timeline-item
		      v-for="(activity, index) in expressData.activities"
		      :key="index"
		      :icon="activity.icon"
		      :type="activity.type"
		      :color="activity.color"
		      :size="activity.size"
		      :timestamp="activity.time" placement="top">
			  
		      <span :class="activity.is_now==1?'now_color':'no_now_color'">{{activity.content}}</span>
			  
		    </el-timeline-item>
		  </el-timeline>
		
			<div v-else style="text-align: center;" class="mt-4">
				<i style="font-size: 50px;color: #999;" class="el-icon-folder-delete "></i>
				<div class="mt-3">未查询到快递數据</div>
			</div>
		<!-- <div class="text-center mt-4" v-if="expressData.is_to==1 && expressData.type==1">
			
			<div @click="toLog(expressData)" style="color: #409EFF;">
				前往对应入账 >>>
			</div>
			
			
		
		</div> -->
		
	
		<div slot="footer" class="dialog-footer">
			<el-button @click="hide">关 闭</el-button>
			
		</div>
	</el-dialog>
</template>

<script>
	import { commondecrypt } from '@/main';
	const user = JSON.parse(window.sessionStorage.getItem('user'))
	export default {
		inject: ['app'],
		props: {
			expressModel: {
				type: Boolean,
				default: false
			},
			expressData: {
				type: Array,
				default: []
			},
			isphone: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				
			}
		},
		methods:{
			toLog(item){
				console.log(item)
				let url = ''
				if(item.order_type==1){
					url = 'user_product'
				}
				if(item.order_type==2){
					url = 'user_first'
				}
				
				
				let data = {
					search:item.order_no
				}
				this.$router.push({
					name: url,
					params:data
				})
				this.hide()
			},
			hide(){
				this.$emit('hide')
			},
			
			
		}
	}
</script>

<style>
	.no_now_color{
		color: #999;
	}
	.now_color{
		color: #181818;
	}
</style>
